import { render, staticRenderFns } from "./returnRecordInitList.vue?vue&type=template&id=c3737f6e&scoped=true"
import script from "./returnRecordInitList.vue?vue&type=script&lang=js"
export * from "./returnRecordInitList.vue?vue&type=script&lang=js"
import style0 from "./returnRecordInitList.vue?vue&type=style&index=0&id=c3737f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3737f6e",
  null
  
)

export default component.exports